import { apiClient } from '@/services/'
import Vue from 'vue'

export const namespaced = true

const // MicrosoftOffice365Path = process.env.VUE_APP_MicrosoftOffice365Path, // TODO - check if this works
  MicrosoftOutlookPath = process.env.VUE_APP_MicrosoftOutlookPath,
  MicrosoftCalendarPath = process.env.VUE_APP_MicrosoftCalendarPath

export const state = {
  announcements: [],
  loadingAnnouncements: false,
  theConfig: null,
  // TODO: Data storage - Preferences Default Links should come from DB - MN
  linksDefaults: [
    {
      title: 'Microsoft Outlook',
      active: 'Y',
      image: 'msOutlook.svg',
      path: MicrosoftOutlookPath,
    },
    {
      title: 'Microsoft Calendar',
      active: 'Y',
      image: 'msCalendar.svg',
      path: MicrosoftCalendarPath,
    },
  ],
  // TODO: Data storage - Import Links should come from DB - MN
  importantLinks: [
    {
      title: 'Safety Hotline',
      active: 'Y',
      image: 'SafetyHotline.png',
      description: `There are many types of unsafe situations. If you see, hear, or suspect an issue or problem on center, the Job Corps Safety Hotline ensures you can quickly report it.`,
      path: 'https://jctips.com/',
      userRoles: [1], //  Students
    },
    {
      title: 'National Web Site ',
      active: 'Y',
      image: 'logo.png',
      path: 'https://www.jobcorps.gov/',
    },
  ],
  // TODO: Data storage - App Links should come from DB - MN
  appLinks: [
    {
      title: 'CS SET',
      active: 'Y',
      image: 'cs_set.gif',
      path: 'http://csset.jobcorps.org/AccessControl/login.aspx?ReturnUrl=%2f',
      userRoles: [1], // Active Students
    },
  ],
}

export const mutations = {
  SET_ANNOUNCEMENTS(state, status) {
    state.announcements = status
  },
  SET_LOADING_ANNOUNCEMENTS(state, status) {
    state.loadingAnnouncements = status
  },
  SET_THE_CONFIG_INFO(state, status) {
    state.theConfig = status
  },
}

export const actions = {
  getAnnouncements({ commit, rootState }) {
    commit('SET_LOADING_ANNOUNCEMENTS', true)
    return apiClient
      .get('/GetAnnouncementsList', {
        params: {
          sAdName: rootState.adName,
        },
      })
      .then((response) => {
        const announcements = response.data.announcements.map((item) => {
          return {
            title: item.announceTitle,
            subtitle: item.subtitle,
            description: item.announceHtml,
            href: item.buttonHref,
            to: item.buttonTo,
            linkText: item.buttonLinkText,
          }
        })

        commit('SET_ANNOUNCEMENTS', announcements)
        commit('SET_LOADING_ANNOUNCEMENTS', false)
      })
  },
  getTheConfig({ commit }) {
    fetch(`${process.env.BASE_URL}/public/config.json`) // fetch is used so that the compiler will not hardcode the values in the code at deploy time , this way it lazy loads - EWB
      .then(function (response) {
        return response.json() // As a function call
      })
      .then(function (data) {
        Vue.prototype.$config = data
        commit('SET_THE_CONFIG_INFO', data)
        // console.info('load in store index')
      })
  },
}
